module.exports = __webpack_public_path__ + "static/img/navbar_5.48e347b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_5.png
// module id = 0M+p
// module chunks = 25